<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    name: string
    initials?: string
    size?: number
  }>(),
  { size: 32, initials: undefined },
)

const computedInitials = computed(() => {
  if (props.initials) return props.initials
  const parts = props.name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0][0].toUpperCase()
  return (parts[0][0] + parts[1][0]).toUpperCase()
})

const style = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${Math.max(10, Math.round(props.size * 0.4))}px`,
}))
</script>

<template>
  <span class="avatar" :style="style">{{ computedInitials }}</span>
</template>

<style scoped>
.avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--accent-soft);
  color: var(--accent-2);
  font-weight: 600;
  letter-spacing: 0.02em;
  user-select: none;
  flex-shrink: 0;
}
</style>
